import axios from "axios";
import { getDomain } from "../../../Utilities/utils";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

// TODO: use react query
const getTransferData = async (transferDataId,source) => {
    const domain = getDomain();
    try {
    const response = await axiosInstance.get(`api/health/transfer-data/${transferDataId}`,
    { params:
        {
          source:source,
        }
      },);
    return response?.data;
    } catch (error) {
        return null;
    }    
}

export default getTransferData;